import { render, staticRenderFns } from "./editProductDrawer.vue?vue&type=template&id=755a5b5e&scoped=true&"
import script from "./editProductDrawer.vue?vue&type=script&lang=js&"
export * from "./editProductDrawer.vue?vue&type=script&lang=js&"
import style0 from "./editProductDrawer.vue?vue&type=style&index=0&id=755a5b5e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "755a5b5e",
  null
  
)

export default component.exports